$(() => {
  // START Minimize Header
  var targets = $('#page-header');
  var previousScrollPosition = window.scrollY;
  var minScrollPosition = 50;

  function handleHeaderMinimization() {
    var currentScrollPosition = window.scrollY;

    if (currentScrollPosition > minScrollPosition) { // downwards
      targets.toggleClass('minimized', true);
    } else { // upwards
      targets.removeClass('minimized');
    }

    previousScrollPosition = currentScrollPosition;
  }

  var triggerTimeout = null;
  var restraintCount = 0;
  var maxRestraintCount = (window.matchMedia('(hover: none)').matches ? 50 : 20);

  handleHeaderMinimization();

  window.addEventListener('scroll', function (event) {
    if (triggerTimeout !== null && restraintCount < maxRestraintCount) {
      clearTimeout(triggerTimeout);
      restraintCount++;
    }

    triggerTimeout = setTimeout(handleHeaderMinimization, 100);
    restraintCount = 0;
  }, Modernizr.passiveeventlisteners ? { passive: true } : false);
  // END Minimize Header

  $('header .obis-bootstrap-menu a.nav-link[href="#"]:not(.dropdown-toggle)').on('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    $(this).parent().children(".dropdown-toggle").click();

    return false;
  });
});